import InfoScreen from '@/components/InfoScreen.vue';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/busstop/:busstopnumber',
    component: InfoScreen,
    props: (route) => ({ busstopnumber: route.params.busstopnumber, painelId: route.query.painelId }),
  },
  { path: '/', redirect: '/busstop/1201' },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
